import { TextCodes } from '@api/types/translation/TextCodes';
import { useAppDispatch, useAuth, useToast } from '@hooks';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton } from '@mui/material';
import { setModalState } from '@store/modal/modal.slice';
import { t } from '@translations';
import { useDealerDetailsContext } from './DealerDetailsProvider';

type CustomerDeleteActionButtonProps = {
  userEmail?: string | null;
};

export const CustomerDeleteActionButton: React.FC<CustomerDeleteActionButtonProps> = ({
  userEmail,
}: CustomerDeleteActionButtonProps) => {
  const { email } = useAuth();
  const { toast } = useToast();
  const dispatch = useAppDispatch();
  const { setDeleteUserEmail, deleteModalId } = useDealerDetailsContext();
  const openModalHandler = () => {
    if (userEmail) {
      setDeleteUserEmail(userEmail);
      dispatch(setModalState({ id: deleteModalId, isVisible: true }));
      return;
    }
    toast({
      message: t(TextCodes.Dealer.Details.MissingEmailAddress),
      severity: 'error',
    });
  };

  return (
    <IconButton onClick={openModalHandler} disabled={userEmail === email}>
      <DeleteIcon />
    </IconButton>
  );
};
